import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const WORDS = ["JAVASCRIPT", "STREAMCAST", "MYSTICAST", "MULTIPLAYER", "GAMEROOM", "VOLTAGE", "OBSIDIAN", "BLAZE", "ARCADE", "POKER", "MISCHIEF", "DIAMOND", "FORTUNE", "TWITCH", "CIPHER"];
const ALPHA = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const MAX_WRONG = 7;

export default function Hangman() {
  const [word, setWord] = useState("");
  const [guesses, setGuesses] = useState([]);
  const [done, setDone] = useState(false);
  const { refreshMe } = useAuth();

  useEffect(() => { reset(); }, []);

  const reset = () => {
    setWord(WORDS[Math.floor(Math.random() * WORDS.length)]);
    setGuesses([]);
    setDone(false);
  };

  const wrong = guesses.filter(g => !word.includes(g)).length;
  const won = word && word.split("").every(c => guesses.includes(c));
  const lost = wrong >= MAX_WRONG;

  useEffect(() => {
    if ((won || lost) && !done) {
      setDone(true);
      api.post("/games/result", { game_slug: "hangman", won }).then(() => { if (won) refreshMe(); }).catch(() => {});
    }
    // eslint-disable-next-line
  }, [won, lost, done]);

  const guess = (l) => {
    if (won || lost || guesses.includes(l)) return;
    setGuesses([...guesses, l]);
  };

  return (
    <div data-testid="game-hangman" className="bg-black/60 border border-white/10 rounded-md p-6 max-w-2xl mx-auto">
      <div className="sc-heading text-2xl font-bold mb-2">Hangman</div>
      <div className="text-xs text-zinc-400 mb-6">Solo word puzzle · free play</div>
      <div className="mb-6">
        <div className="text-4xl font-mono tracking-[0.4em] font-black text-center">
          {word.split("").map((c, i) => (
            <span key={i} className={guesses.includes(c) ? "text-white" : "text-zinc-700"}>
              {guesses.includes(c) || lost ? c : "_"}{" "}
            </span>
          ))}
        </div>
      </div>
      <div className="text-center mb-4">
        <span className="sc-label">Wrong</span> <span className={wrong >= MAX_WRONG - 2 ? "text-[#FF3366]" : "text-[#F59E0B]"}>{wrong}/{MAX_WRONG}</span>
      </div>
      <div className="flex flex-wrap gap-1.5 justify-center mb-4">
        {ALPHA.map(l => {
          const used = guesses.includes(l);
          const inWord = used && word.includes(l);
          return (
            <button
              key={l}
              data-testid={`hangman-${l}`}
              disabled={used || won || lost}
              onClick={() => guess(l)}
              className={`w-8 h-8 text-sm font-bold rounded-sm border ${
                inWord ? "border-[#10B981] text-[#10B981] bg-[#10B981]/10" :
                used ? "border-[#FF3366]/40 text-[#FF3366] bg-[#FF3366]/5" :
                "border-white/10 hover:border-[#FF3366]/40"
              }`}
            >{l}</button>
          );
        })}
      </div>
      {won && <div className="text-center text-[#10B981] font-bold mb-3">You won!</div>}
      {lost && <div className="text-center text-[#FF3366] font-bold mb-3">Out of guesses — word was {word}</div>}
      <div className="text-center">
        <button onClick={reset} className="sc-btn-ghost text-xs">New Word</button>
      </div>
    </div>
  );
}
